// extracted by mini-css-extract-plugin
export default {"containprod":"WC","containprod2":"XC","title":"YC","servings":"ZC","recommendation":"aE","image":"bE","flavorswrap":"cE","flavorsgroupwrap":"eE","moredetailsWrap":"fE","infoWrap":"gE","price":"hE","regularPrice":"iE","netPrice":"jE","addtocartcontainer":"kE","error":"lE"};
    if(module.hot) {
      // 1715632477967
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  